module.exports = {
    Copyright:'Copyright © 2024',
	settings:'Settings',
	Ranking:'Ranking',
	Questions:'Questions',
	Contents:'Contents',
	Edit:'Edit',
	Save:'Save',
	Member_since:'Member since',
	Last_login:'Last login',
	day:'Daily Package',
	week:'Weekly Package',
	Login:'Login',
  OTP:'OTP',
  Get:'Get',
  RESEND:'RESEND',
  codeTips1:'Please enter your phone number',
  codeTips2:'OTP is sent to your phone. Please check and enter.',
  codeTips3:'Please fill in the correct otp',
	My_score:'My score',
  loginCode:'Login/enter',
	Terms_of_Use:'Study Go Terms of Use',
	no_data:'no data',
	Ranking_Score:'Ranking Score',
	Today:'Today',
	Week_Rank:'Weekly',
	Monthly:'Monthly',
	Question_List:'Questions',
	Question_ID:'Question ID',
	Question_Status:'Question Status',
	Questions_are_answered:'Questions are answered',
	Questions_are_not_answered:'Questions are not answered',
	Continue:'Continue',
	Get_more_questions:'Get more questions',
	Submit:'Submit',
	Your_correct_answer_number_is:'Your correct answer number is',
	Your_total_score_is:'Your total score is',
	Review:'Review',
	No_Question:'No Question',
	Content_List:'Content List',
	Read_more:'Read more',
	more:'More',
	noMore:'No more',
  clickMore:'Click for More',
	des2:'Are you sure you want to unsubscribe?',
	tips:'Please enter phone number',
	tips2:'Operation Failed',
	msg2:'You are now going to purchase a new set of quizzes, you will be charge for 149ks per set of quizzes',
	msg1:'You have now finished playing 5 quests. Please purchase more tomorrow to continue playing.',
	loading:'loading',
	loadMore:'Pull up to load more',
	loadMore2:"It's over!",

  name:'Name',
  seeMore:'See More',
  pleaseSelect:'please select',
	Next:'Next',
	Back:'Back',
	cancel:'Cancel',
	Confirm:'Sure',
	No:'No',
	OK:'OK',
	Yes:'Yes',
	des:'Are you sure you want to unsubscribe?',
	myAccount:'Me',
  phone_number:'Phone Number',
	FAQs:'FAQs',
	T_C:'T&C',
	T_C2:'Terms of Use',
	Privacy_Policy:'privacy & policy',
	Unsubscribe:'Unsubscribe',
  regTips1:'Register today!',
  regTips2:'Register now to access premium study resources & expert guidance.',
  regTips3:'It\’s only 99 ks per day!',
  regTips4:'Enter Your Phone number here:',
  hey:'Hey, ',
  homeTips1:'Keep Learning!',
  homeTips2:'Select a chapter for exploration.',
  History:'History'
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js